import type { FC, MouseEventHandler, PropsWithChildren } from 'react';
import React from 'react';

import { cnTumbler } from '../Tumbler.cn';

import './Tumbler-Label.css';

type TumblerLabelProps = PropsWithChildren<{
    disabled?: boolean;
    htmlFor: string;
    id: string;
    onClick: MouseEventHandler<HTMLSpanElement>;
}>;

export const TumblerLabel: FC<TumblerLabelProps> = ({
    disabled,
    htmlFor,
    id,
    onClick,
    children,
}) => (
    <label
        aria-hidden="true"
        htmlFor={disabled ? undefined : htmlFor}
        id={id}
        onClick={onClick}
        className={cnTumbler('Label')}
    >
        {children}
    </label>
);
